export default __webpack_public_path__ + "static/media/facomHeader1.08739d79.png";